import { Pane, Heading, Paragraph, Card } from 'evergreen-ui';
import HeroBanner from '../commons/HeroBanner';

export default function ChiSiamoPage() {
  const valori = ['Ascolto', 'Presenza', 'Rispetto', 'Fiducia'];

  return (
    <Pane className="public-page-container">
      {/* HERO SECTION */}
      <HeroBanner 
        title="Chi siamo" 
        subtitle="Persone, prima di tutto"
        bgImage="/chisiamo(2).png" 
      />
      
      <Pane maxWidth={800} marginX="auto" paddingY={80} paddingX={20} textAlign="center">
        
        {/* TESTO PRINCIPALE */}
        <Pane marginBottom={60}>
          <Paragraph size={600} marginBottom={24} lineHeight="1.8">
            Siamo una comunità educativa che accoglie minori in situazioni di fragilità.
          </Paragraph>
          <Paragraph size={600} marginBottom={24} lineHeight="1.8">
            Crediamo nelle relazioni, nella continuità, nella possibilità di ricominciare.
          </Paragraph>
          <Paragraph size={600} color="muted" fontStyle="italic" lineHeight="1.8">
            Ogni ragazzo porta con sé una storia unica.<br/>
            Noi siamo qui per accompagnarla.
          </Paragraph>
        </Pane>
        
        {/* VALORI */}
        <Pane paddingTop={40} borderTop="muted">
          <Heading size={800} marginBottom={40} color="#2a3b2c">
            I nostri valori
          </Heading>
          
          <Pane display="flex" justifyContent="center" gap={24} flexWrap="wrap">
            {valori.map((valore, index) => (
              <Card 
                key={index} 
                backgroundColor="tint2" 
                paddingY={32} 
                paddingX={40} 
                borderRadius={12} 
                elevation={1} 
                minWidth={160}
                display="flex"
                justifyContent="center"
                alignItems="center"
                hoverElevation={3} /* Leggero effetto hover supportato da Evergreen */
                cursor="default"
              >
                <Heading size={600} color="success">{valore}</Heading>
              </Card>
            ))}
          </Pane>
        </Pane>

      </Pane>
    </Pane>
  );
}